import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'

// Connects to data-controller="recent-announcements"
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    const day = new Date().getDay()
    if (localStorage.getItem('modal_closed') !== `${day}`) {
      this.showDialog()
    }
    this.initializeSwiper()
  }

  initializeSwiper() {
    this.swiper = new Swiper('.announcement-swiper', {
      modules: [Pagination, Navigation, Autoplay],
      loop: true,
      // autoHeight: true,
      grabCursor: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      effect: 'slide',
      fadeEffect: {
        crossFade: true
      },
    })
  }

  showDialog() {
    this.dialogTarget.showModal()
  }

  closeDialog() {
    this.dialogTarget.close()
    localStorage.setItem('modal_closed', new Date().getDay())
  }
}
